import $ from 'jquery';
import AsyncApi from '../AsyncApi';

export class GoogleRecaptchaRuntime {
  static frontend(el: HTMLElement, opt: any) {
    return new GoogleRecaptchaRuntime(el, opt);
  }

  instance = null;
  $input: JQuery;

  constructor(el: HTMLElement, opt: ReCaptchaV2.Parameters) {
    const container = el.getElementsByClassName('g-recaptcha');
    if (container.length === 1) {
      const wrapper = container.item(0) as HTMLElement;
      this.$input = $(el).children('input[type=hidden]');
      AsyncApi.onLoad((grc) => {
        try {
          opt.callback = (s) => {
            this.$input.val(s);
          };
          this.instance = grc.render(wrapper, opt);
        } catch (e) {
          console.info('Recaptcha re-init warning', e);
        }
      });
    }
  }
}
